import { all } from 'redux-saga/effects';

import appManagementWatcherSaga from 'pages/AppManagement/saga';
import authManagementWatcherSaga from 'pages/AuthenticationManagement/saga';
import uploadManagementWatcherSaga from 'pages/UploadManagement/saga';
import AssetsManagementWatcherSaga from 'pages/AssetsManagement/saga';
import InfraManagementWatcherSaga from 'pages/InfraManagement/saga';
import CTAManagementWatcherSaga from 'pages/DashboardManagement/saga';
import UploadFormManagementWatcherSaga from 'containers/UploadForm/saga';
import AnalyticsManagementWatcherSaga from 'pages/AnalyticsManagement/saga';
import LeadsManagementWatcherSaga from 'pages/LeadsManagement/saga';
import CurationManagementWatcherSaga from 'pages/CurationManagement/saga';
import FeedManagementWatcherSaga from 'pages/FeedManagement/saga';
import CourseManagementWatcherSaga from 'pages/CoursesManagement/saga';
import settingManagementWatcherSaga from 'pages/SettingsManagement/saga';

export function* rootSaga() {
  yield all([
    appManagementWatcherSaga(),
    authManagementWatcherSaga(),
    uploadManagementWatcherSaga(),
    AssetsManagementWatcherSaga(),
    InfraManagementWatcherSaga(),
    CTAManagementWatcherSaga(),
    UploadFormManagementWatcherSaga(),
    AnalyticsManagementWatcherSaga(),
    LeadsManagementWatcherSaga(),
    CurationManagementWatcherSaga(),
    FeedManagementWatcherSaga(),
    CourseManagementWatcherSaga(),
    settingManagementWatcherSaga()
  ]);
}

export default rootSaga;
